/**
 * @generated SignedSource<<192696eb41bc42a27061d590d41c945c>>
 * @relayHash 31cc56de62b91ad81dab7c63784ec1d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 529e4a86708354a1f72fd05479e3a731aae4550fcda440d26f53c159807689f0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IncidentsPageLinkedServicesWrapperSrcQuery } from './IncidentsPageLinkedServicesWrapperSrcQuery.graphql';

const node: PreloadableConcreteRequest<IncidentsPageLinkedServicesWrapperSrcQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "529e4a86708354a1f72fd05479e3a731aae4550fcda440d26f53c159807689f0",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "associatedComponents"
          ]
        }
      ]
    },
    "name": "IncidentsPageLinkedServicesWrapperSrcQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
